(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("element-ui"), require("vue"));
	else if(typeof define === 'function' && define.amd)
		define(["element-ui", "vue"], factory);
	else if(typeof exports === 'object')
		exports["el-form-plus"] = factory(require("element-ui"), require("vue"));
	else
		root["el-form-plus"] = factory(root["element-ui"], root["vue"]);
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__5f72__, __WEBPACK_EXTERNAL_MODULE__8bbf__) {
return 